import Vue from 'vue'
import VueRouter from 'vue-router'
import _import from '@/utils/import'
const Layout = _import('layout/Layout')

Vue.use(VueRouter)

export const constantRouterMap = [
  {
    path: '/401',
    component: _import('errorPage/401'),
    hidden: true
  },
  {
    path: '/404',
    component: _import('errorPage/404'),
    hidden: true
  },
  {
    path: '/login',
    component: _import('login/index'),
    hidden: true
  },
  {
    path: '/lock',
    component: _import('lock/index'),
    name: 'lock',
    hidden: true
  },
  {
    path: '/bigScreen',
    component: _import('bigScreen/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: 'shortCuts',
    children: [
      {
        path: 'shortCuts',
        name: 'shortCuts',
        component: _import('shortCuts/index'),
        meta: {
          title: '快捷功能',
          icon: 'shortCuts',
          noCache: true
        }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    redirect: 'dataScreen',
    children: [
      {
        path: 'dataScreen',
        name: 'dataScreen',
        component: _import('dataScreenV2/index'),
        meta: {
          title: '数据大屏',
          icon: 'dataScreen',
          noCache: true
        }
      }
    ]
  },

  // 个人中心
  {
    path: '/profile',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        component: _import('profile/index'),
        name: 'profile',
        meta: {
          title: '个人中心',
          icon: 'test'
        }
      }
    ]
  }
]

export const router = new VueRouter({
  routes: constantRouterMap,
  scrollBehavior: () => ({ y: 0 })
})
